import * as yup from "yup";

export const validationSchema = yup.object().shape({
  // Licence number validation
  licence_number: yup
    .string()
    .matches(
      /^[A-Z0-9\s]{10,20}$/,
      "Invalid licence number format (must be alphanumeric, allow spaces, 10-20 characters)"
    ) // Matches licence numbers like "TN62 20190001999"
    .required("Licence number is required"),
});
